import axios from "axios";
import config from "../config";
import { store } from "../store";
import {
  getWebAuthToken,
  getWebAuthTokenMirror,
} from "../utils/authTokenStorage";

async function getAuthHeaders() {
  const token =
    (await getWebAuthToken().catch(() => null)) ||
    store?.getState()?.auth?.accessToken ||
    getWebAuthTokenMirror() ||
    "";
  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

export const onboardingApi = {
  getPsaCustomers: async (mspId: number): Promise<Array<{ id?: string; name?: string; [key: string]: unknown }>> => {
    const response = await axios.get(
      `${config.apiUrl}/onboarding/psa-customers`,
      { params: { msp_id: mspId }, headers: await getAuthHeaders() }
    );
    return response.data || [];
  },

  importAllCustomers: async (
    mspId: number,
    psaCustomerIds?: string[]
  ): Promise<{
    success: boolean;
    imported: number;
    skipped: number;
    customers: Array<{ id: number; name: string; psa_customer_id?: string }>;
  }> => {
    const response = await axios.post(
      `${config.apiUrl}/onboarding/customers/import-all`,
      {
        msp_id: mspId,
        ...(psaCustomerIds && psaCustomerIds.length > 0 ? { psa_customer_ids: psaCustomerIds } : {}),
      },
      { headers: await getAuthHeaders() }
    );
    return response.data;
  },
};
